import createReducer from '../utils/createReducer';
import {
  TEMPLATES_REQUEST,
  TEMPLATES_FAILURE,
  TEMPLATES_SUCCESS,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: {},
  token: null,
};

export default createReducer(initialState, {
  [TEMPLATES_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [TEMPLATES_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: {
        ...state.data,
        [payload.type]: payload.data ? [].concat(payload.data) : [],
      },
      token: payload.token,
    })
  ),
  [TEMPLATES_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/templates.js